import { render, staticRenderFns } from "./BodyAttribute.vue?vue&type=template&id=29782b6a&scoped=true&"
import script from "./BodyAttribute.vue?vue&type=script&lang=js&"
export * from "./BodyAttribute.vue?vue&type=script&lang=js&"
import style0 from "./BodyAttribute.vue?vue&type=style&index=0&id=29782b6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29782b6a",
  null
  
)

export default component.exports